import { AppProvider, Frame } from "@shopify/polaris";
import "@shopify/polaris/build/esm/styles.css";
import enTranslations from "@shopify/polaris/locales/en.json";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AppNav from "./components/AppNav";
import ErrorBoundary from "./components/ErrorBoundary";
import VendorList from "./pages/VendorList";
import VendorCreate from "./pages/VendorCreate";
import VendorDetail from "./pages/VendorDetail";
import POBuilder from "./pages/POBuilder";
import PODetail from "./pages/PODetail";
import POList from "./pages/POList";
import Receiving from "./pages/Receiving";
import ReceivingList from "./pages/ReceivingList";
import Dashboard from "./pages/Dashboard";
import PriceLabels from "./pages/PriceLabels";
import Settings from "./pages/Settings";

export default function App() {
  return (
    <AppProvider i18n={enTranslations}>
      <BrowserRouter>
        <AppNav />
        <Frame>
        <ErrorBoundary>
        <Routes>
          <Route path="/" element={<VendorList />} />
          <Route path="/vendors/new" element={<VendorCreate />} />
          <Route path="/vendors/:vendorId" element={<VendorDetail />} />
          <Route path="/vendors/:vendorId/edit" element={<VendorCreate />} />
          <Route path="/vendors/:vendorId/purchase-orders/new" element={<POBuilder />} />
          <Route path="/purchase-orders" element={<POList />} />
          <Route path="/purchase-orders/:poId" element={<PODetail />} />
          <Route path="/purchase-orders/:poId/edit" element={<POBuilder />} />
          <Route path="/receiving" element={<ReceivingList />} />
          <Route path="/purchase-orders/:poId/receive" element={<Receiving />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/price-labels" element={<PriceLabels />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </ErrorBoundary>
        </Frame>
      </BrowserRouter>
    </AppProvider>
  );
}
